/**
 * CRUD操作が存在するObjectStoreの名前の配列
 * 文字列が型に含まれているかを確認するために使用する
 */
export const OBJECT_STORE_NAME_WITH_CRUD = ['inspection_result', 'inspector_list'] as const

/**
 * CRUD操作が存在しないObjectStoreの名前の配列
 * 文字列が型に含まれているかを確認するために使用する
 */
export const OBJECT_STORE_NAME_WITHOUT_CRUD = [
  'building',
  'disaster',
  'government_setting',
  'admin_districts'
] as const
